import { useState, useEffect } from 'react';
import { getFirestore, collection, getDocs } from 'firebase/firestore';

const useFetchTopics = () => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTopics = async () => {
      const db = getFirestore();
      try {
        const querySnapshot = await getDocs(collection(db, 'topics'));
        const fetchedTopics = [];
        querySnapshot.forEach((doc) => {
          fetchedTopics.push(doc.data().name); 
        });
        setTopics(fetchedTopics);
      } catch (err) {
        setError('Failed to fetch topics');
      } finally {
        setLoading(false);
      }
    };

    fetchTopics();
  }, []);

  return { topics, loading, error };
};

export default useFetchTopics;
